module.exports = __webpack_public_path__ + "static/media/medial-nonflexion-up-3.cc975249.png";